
























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "@/models/Application";
import { Debouncer } from "@/models/Debouncer";
import { Parser } from "json2csv";

@Component({})
export default class extends Vue {
    public headers = [
        { text: "Date", value: "date" },
        { text: "Total Sales", value: "total_sales" },
    ];

    public fromDate: any = null;
    public toDate: any = null;

    public models: any[] = [];

    public async search() {
        try {
            const result = await app.reportService.getSalesPerDay(
                this.fromDate,
                this.toDate
            );
            this.models = result;
        } catch (e) {
            console.log(e);
        }
    }
    public download(filename: any, data: any) {
        const element = document.createElement("a");
        element.style.display = "none";
        element.setAttribute("href", "data:text/plain," + data);
        element.setAttribute("download", filename);
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }

    public exportToExcel() {
        const data = this.models.map(e => {
            return {
                Date: e.date,
                TotalSales: e.total_sales
            };
        });

        const fields = [
            "Date",
            "TotalSales"
        ];

        const perser = new Parser({ fields });
        const csv = perser.parse(data);
        this.download("Report.csv", csv);
    }
}
